import request from '@/api/request'

export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get',
  })
}

export function logout() {
  return request({
    baseURL: '',
    url: '/logout',
    method: 'post'
  })
}

export function getRouters() {
  return request({
    url: '/v2/getRouters',
    method: 'get',
  })
}

export function getPrincipal() {
  return request({
    url: '/v2/principal',
    method: 'get',
  })
}
